import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { TripReelView } from './trip-reel-view';

/**
 * Thin route wrapper for /app/trips/:id/reel.
 * Handles the URL → props translation so TripReelView stays a pure modal.
 */
export function TripReelPage() {
  const { id: tripId } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  if (!tripId) return null;

  return (
    <TripReelView
      tripId={tripId}
      startActivityId={searchParams.get('activity') ?? undefined}
      onClose={() => navigate(-1)}
    />
  );
}
